import { Dialog, useMediaQuery } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CustomDialogTitle from "components/customDialog/customDialogTitle";
import { MOBILE_MEDIA_QUERY } from "constants/mediaQueries";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { styledDialogChildSX } from "styled/styledSXProperties/styledDialogueSX";
import { baseStyledPaperSX } from "styled/styledSXProperties/styledPaperSX";

import { L4_CATEGORY } from "../../constants/generalConstants";
import CardCarousel from "./cardCarousel";
import L4HomePageCard from "./l4HomePageCard";

const HomepageL4Dialogue = ({ closeModal, isOpen }) => {
    const isDesktop = useMediaQuery(MOBILE_MEDIA_QUERY);
    const darkMode = useSelector((state) => state.general.darkMode);

    const [L3CategorySelected, L4Data, team] = useSelector(
        (state) => state.homepageCategorySelection
    );

    return (
        <>
            {L4Data && (
                <Dialog
                    fullScreen={!isDesktop}
                    fullWidth
                    maxWidth="lg"
                    onClose={closeModal}
                    open={isOpen}
                    PaperProps={{
                        sx: baseStyledPaperSX(darkMode),
                    }}
                >
                    <CustomDialogTitle
                        onClose={closeModal}
                        title={L3CategorySelected}
                        tooltip="Close Invoice Attachments"
                    />
                    <DialogContent sx={styledDialogChildSX}>
                        <Typography
                            variant="h6"
                            fontWeight="normal"
                            align="left"
                            color="text.secondary"
                            paddingBottom={"25px"}
                        >
                            Select a category from the options below to be taken
                            to the Product List screen.
                        </Typography>
                        {isDesktop ? (
                            <>
                                <CardCarousel
                                    tilesArray={L4Data}
                                    tile={L4_CATEGORY}
                                    team={team}
                                />
                            </>
                        ) : (
                            Object.keys(L4Data).map((tileObj, index) => {
                                return (
                                    <Grid xs={12} key={index}>
                                        <L4HomePageCard
                                            name={tileObj}
                                            team={team}
                                            data={L4Data}
                                        />
                                    </Grid>
                                );
                            })
                        )}
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};

HomepageL4Dialogue.propTypes = {
    closeModal: PropTypes.func,
    isOpen: PropTypes.bool,
    l4Data: PropTypes.object,
};

export default HomepageL4Dialogue;
